import React from 'react'
import PropTypes from 'prop-types'
import {
  CX,
  BREAKPOINT_SMALL,
} from '../constants'
import { me } from '../initial_state'
import Responsive from '../features/ui/util/responsive_component'
import Button from './button'
import Text from './text'
import ReactionTypeImage from './reaction_type_image'
import ReactionsPopoverInitiator from './reactions_popover_initiator'

class StatusActionBarItem extends React.PureComponent {

  render() {
    const {
      title,
      icon,
      active,
      disabled,
      buttonRef,
      altTitle,
      isCompact,
      isLike,
      labelNumber,
      reactionTypeId,
      onClick,
      statusId,
      iconColor,
      to,
      isVertical,
      isXS,
    } = this.props

    if (disabled && isVertical) return null

    const keepIcon = !reactionTypeId || `${reactionTypeId}` === '1'
    const color = active ? 'brand' : iconColor || 'secondary'
    const weight = active ? 'bold' : 'medium'
    const iconSize = isXS && !isVertical ? '15px' : '16px' 

    const btnClasses = CX({
      aiCenter: 1,
      jcCenter: 1, 
      noSelect: 1,
      capitalize: 1,
      h100PC: !isVertical,
      h40PX: isVertical,
      w40PX: isVertical,
      mb5: isVertical,
      px10: !isCompact,
      boxShadowPopover: isVertical,
      bgSubtle_onHover: !disabled,
      flexRow: !keepIcon && !!reactionTypeId,
    })

    const btnContainerClasses = CX({
      d: 1,
      px5: 1,
      noSelect: 1,
      circle: isVertical, 
      h100PC: !isVertical,
      flexNormal: !isVertical,
    })

    const theButton = (
      <Button
        isBlock
        radiusSmall={!isVertical}
        backgroundColor={isVertical ? 'white' : 'none'}
        title={altTitle || title}
        color={color}
        buttonRef={buttonRef}
        className={btnClasses}
        onClick={!isLike ? onClick : undefined}
        isDisabled={disabled}
        icon={keepIcon ? icon : undefined}
        to={!isLike ? to : undefined}
        iconSize={iconSize}
        iconClassName={[_s.d, _s.inheritFill].join(' ')}
      >

        {
          (!keepIcon && !!reactionTypeId) && 
          <ReactionTypeImage reactionTypeId={`${reactionTypeId}`} size='15px' />
        }

        {
          !!title && !isCompact && !labelNumber &&
          <Responsive min={BREAKPOINT_SMALL}>
            <Text color='inherit' size='small' weight={weight} className={[_s.ml10, _s.capitalize].join(' ')}>
              {altTitle || title}
            </Text>
          </Responsive>            
        }
        {
          !!labelNumber &&
          <Text color='inherit' size='small' weight={weight} className={_s.ml10}>
            {labelNumber}
          </Text>
        }
      </Button>
    )

    if (isLike) {
      return (
        <div className={btnContainerClasses}>
          <ReactionsPopoverInitiator
            statusId={statusId}
            onClick={onClick}
            isDisabled={disabled}
          >
            {theButton}
          </ReactionsPopoverInitiator>
        </div>
      )
    }

    return (
      <div className={btnContainerClasses}>
        <Button
          isBlock
          radiusSmall={!isVertical}
          backgroundColor={isVertical ? 'white' : 'none'}
          title={altTitle || title}
          color={color}
          buttonRef={buttonRef}
          className={btnClasses}
          onClick={(!isLike || !me) ? onClick : undefined}
          isDisabled={disabled}
          icon={keepIcon ? icon : undefined}
          to={!isLike ? to : undefined}
          iconSize={iconSize}
          iconClassName={[_s.d, _s.inheritFill].join(' ')}
        >

          {
            (!keepIcon && !!reactionTypeId) && 
            <ReactionTypeImage reactionTypeId={reactionTypeId} size='15px' />
          }

          {
            !!title && !isCompact && !labelNumber &&
            <Responsive min={BREAKPOINT_SMALL}>
              <Text color='inherit' size='small' weight={weight} className={_s.ml10}>
                {labelNumber ? labelNumber : title}
              </Text>
            </Responsive>            
          }
          {
            !!labelNumber &&
            <Text color='inherit' size='small' weight={weight} className={_s.ml10}>
              {labelNumber}
            </Text>
          }
        </Button>
      </div>
    )
  }

}

StatusActionBarItem.propTypes = {
  title: PropTypes.string.isRequired,
  altTitle: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onOpenReactions: PropTypes.func,
  onCancelReactions: PropTypes.func,
  icon: PropTypes.string.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  isCompact: PropTypes.bool,
  isLike: PropTypes.bool,
  labelNumber: PropTypes.string,
  reactionTypeId: PropTypes.string,
  to: PropTypes.string,
  statusId: PropTypes.string,
  isVertical: PropTypes.bool,
  buttonRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]),
}

export default StatusActionBarItem